import refresh from '@ihs-widget/assets/svg/common/refresh.svg';
import refresh_dark from '@ihs-widget/assets/svg/common/refresh_dark.svg';
import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { useTheme } from '@ihs-widget/stores/useTheme';
import { useTranslations } from "../../translation/TranslationContext";
import { T } from "@ihs-widget/utils/enums";

interface RefreshIconAndTextProps {
    addClass?: string;
}

export default function RefreshIconAndText({ addClass }: RefreshIconAndTextProps) {
    const language = useLanguage();
    const t = useTranslations(language);
    const { theme } = useTheme();

    return (
        <div className={`h-full w-full bg-monoY dark:bg-[#222222] flex flex-col justify-start items-center text-base110 dark:text-monoY
            text-[14px] leading-[20px] font-normal font-robotoRegular ${addClass}`}>
            <img src={theme === T.DARK ? refresh_dark : refresh} alt="refresh" className="w-[32px] h-[32px] mb-[10px]" />
            <div className='text-center'>{t[`InHouseStats.NotFoundTitle`]}</div>
            <div className='text-center'>{t[`InHouseStats.NotFoundSubtitle`]}</div>
        </div>
    )
}
